import React, { useContext, useEffect, useState, useRef } from "react";
import AppContext from "../../../context/AppContext";
import { getWorkflows } from "../../../service/workflow";
import ReactSelector from "../CommonReactSelector";
import { components } from 'react-select';
import { fetchTasks } from "../../../service/Task";
const Placeholder = (props) => {
  return <components.Placeholder {...props} />;
};

const ActivitySelect = ({ setWorkflowName, showPlaceholder = false, placeholder = "", optionData = [], height = "auto", classname, defaultValue, menuPortalTarget, rounded, ...rest }) => {
  const [data, setData] = useState([]);
  const { setWorkflowId, userType, selectedOption, setSelectedOption, setTaskData, setTotalPageSize, updateActivityId, projectId, setActivityId } = useContext(AppContext);
  useEffect(() => {
    const storedOption = localStorage.getItem("selectedActivity");
    if (storedOption) {
      setSelectedOption(storedOption);
      setWorkflowId(storedOption);
    }
  }, []); 

  // Every current caller of <ActivitySelect> (TaskListToolbar.js,
  // MapViewToolbar.js) already fetches the activity list itself
  // and passes it in via `optionData`. Below, `options` always reads from
  // `optionData` first (it defaults to `[]`, which still satisfies
  // Array.isArray, so the `data` branch is never actually reached) -- meaning
  // this effect's own get-activities call re-fetched the exact same list a
  // second time on every screen that renders this component, for a `data`
  // value that was never used for rendering. Commented out rather than
  // deleted in case a future caller relies on this internal fetch instead of
  // passing optionData.
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await getWorkflows(projectId, userType);
  //       const workflows = response.body.value;
  //       if (Array.isArray(workflows)) {
  //         setData(workflows);
  //         const workflowMap = workflows.reduce((map, workflow) => {
  //           map[workflow.workflowId] = workflow.workflowName;
  //           return map;
  //         }, {});
  //         const selectedWorkflow = workflows.find(
  //           (workflow) => workflow.workflowId === selectedOption
  //         );
  //
  //       } else {
  //         console.error("Expected an array but got:", workflows);
  //         setData([]);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching workflows:", error);
  //     }
  //   };
  //   if (projectId) fetchData();
  //
  // }, [projectId]);

 
  const handleChangeActivity = async (selectedValue) => {
    console.log('selectedValue', selectedValue)
    const data = await fetchTasks({ workflowIds: selectedValue.value, priority: "Priority", active: "Status", currentPage: 0, pageSize: 10 });
    setTaskData(data?.taskList)
    setWorkflowId(selectedValue?.value)
    setActivityId?.(selectedValue?.value)
    setTotalPageSize(data?.totalSize)
    updateActivityId(selectedValue.value)
    setWorkflowName(selectedValue.label)
    localStorage.setItem("workflowName", selectedValue.label);
  }
  const options = Array.isArray(optionData) 
  ? optionData.map(item => ({ value: item.workflowId, label: item.workflowName }))
  : Array.isArray(data)
    ? data.map(item => ({ value: item.workflowId, label: item.workflowName }))
    : [];

  useEffect(() => {
    if (defaultValue && defaultValue.length > 0) {
      const valueString = defaultValue.map(item => item.value).join(',');
      setWorkflowId(valueString);
    }
  }, [defaultValue]);

  return (
    <>
      <div className={`w-full flex items-center gap-2 ${classname || ''}`}>
        <div className={`w-full min-w-[180px] max-w-[280px] ${rounded || ""}`}>
          <ReactSelector
            {...rest}
            options={options}
            height={height || "36px"}
            components={showPlaceholder ? Placeholder : {}}
            placeholder={placeholder}
            onChange={handleChangeActivity}
            isClearable={false}
            value={defaultValue}
            menuPortalTarget={menuPortalTarget}
          />
        </div>
      </div>
    </>
  );
};

export default ActivitySelect;
